const defaultTopicIdOther = 5;

export { defaultTopicIdOther };
